'use client';

import { QueryKeys } from '@/constants/query-keys';
import { moviesApiService } from '@/services/(frontend)/movies/movie-api.service';
import { MovieCatalogRequest, MovieCatalogResponse } from '@/types/movie-catalog';
import { useQuery } from '@tanstack/react-query';
import { useDynamicStaleTime } from '../shared/dynamic-stale-time';

export const useMovieCatalog = (request: MovieCatalogRequest): ReturnType<typeof useQuery<MovieCatalogResponse | null>> => {
  const updateQueryStaleTime = useDynamicStaleTime();

  return useQuery<MovieCatalogResponse | null>({
    queryFn: async ({ signal }) => {
      const response = await moviesApiService.getMovieCatalog(request, signal);

      if (response.headers) {
        updateQueryStaleTime(QueryKeys.global.movieCatalog(request), response.headers);
      }

      return response.data;
    },
    queryKey: QueryKeys.global.movieCatalog(request),
  });
};
